import { BsHeartFill, BsHeartbreakFill } from "react-icons/bs";

//API Consts
export const stacksApi = { testnet: 'https://api.testnet.hiro.so', mainnet: 'https://api.hiro.so' };
//export const stacksApi = 'https://api.hiro.so';
export const sentimentApi = 'https://sentiment.derupt.io';
export const sentimentExtensionApi = 'https://sentiment.derupt.io/extensions';

//Explorer Consts
export const stacksExplorer = 'https://explorer.hiro.so';
//export const stacksExplorerParam = '?chain=mainnet';
export const stacksExplorerParam = '?chain=testnet';

//Network Consts
export const clientNetwork = "testnet";
//export const clientNetwork = "mainnet";

//Contracts Deployer Const
export const contractDeployer = "ST1ZK4MRVTQQJMVAAJQWBV2WPQ87QV2851YCTHD7X";
// export const contractDeployer = "MAINNET-DEPLOYER-ADDRESS";

// Constracts Consts
export const cryptoCashCoreAddress = contractDeployer + '.cryptocash-core';
export const cryptoCashTokenAddress = contractDeployer + '.cryptocash-token::CC';
export const deruptInterfaceAddress = contractDeployer + '.derupt-interfaces::derupt-interface-token';
export const deruptFeedContractAddress = contractDeployer + '.derupt-feed';
export const deruptSentimentAddress = contractDeployer + '.derupt-sentiment';
export const deruptExtensionRegistrationAddress = contractDeployer + '.derupt-ext-reg';
export const deruptMinersAddress = contractDeployer + '.derupt-miners';
export const deruptStackersAddress = contractDeployer + '.derupt-stackers';
export const deruptProfilesAddress = contractDeployer + '.derupt-profiles';

export const profileContract = 'derupt-debug-profile';

export const deruptarsNFTContractAddress = 'STVG43BSMRD85XJSRPFJKR2BPMMZNP3XBSCMZC6T.deruptars::deruptars';
// export const deruptarsNFTContractAddress = 'SP2KAF9RF86PVX3NEE27DFV1CQX0T4WGR41X3S45C.deruptars::deruptars';

export const bnsContractAddress = 'SP000000000000000000002Q6VF78.bns'; //v1 bns

//Dev Const - should be the same as the relative Interface nft owner
export const devPrincipal = "ST20W9RVMPQPZFXAH2KKCKJ0W0N4P8M6DGZXB2489";
export const devStoragePath = ""; // Needed for Interface Extensions List source

// export const devPrincipal = "MAINNET-DEV-ADDRESS"; 
// export const devStoragePath = "";

//Other Consts
export const sentimentOptions = [
    {
        value: 'favorable',
        functionName: 'favorable-reply-message',
        icon: <BsHeartFill size={24} />
    },
    {
        value: 'unfavorable',
        functionName: 'unfavorable-reply-message',
        icon: <BsHeartbreakFill size={24} />
    },
];

// export const userExtensionsFileName = "userExtension-3.json";
export const userExtensionsFileName = "myExtensions-2.json";
export const interfaceExtensionsFileName = "interfaceExtension-2.json";

export const deruptPfp = 'derupt_pfp.json';
export const derupt_avatar = 'derupt_avatar.png';

export const exhibitIndexFileName = 'derupt_exhibits_05.json';
